import { getStaticUrl } from "../../../../../utils";
import { useEffect, useState } from "react";
import { getCitiesGallery } from "../../../../../api/transport/configurationTransport";
import { PhotoCarousel } from "../../../../../components/PhotoCarousel";

export const CitiesCarousel = () => {
    const [images, setImages] = useState([
        "/uploads/images/contests/cities/gallery/cities_00001.png",
        "/uploads/images/contests/cities/gallery/cities_00002.png",
        "/uploads/images/contests/cities/gallery/cities_00003.png",
        "/uploads/images/contests/cities/gallery/cities_00004.png",
        "/uploads/images/contests/cities/gallery/cities_00005.png",
        "/uploads/images/contests/cities/gallery/cities_00006.png",
        "/uploads/images/contests/cities/gallery/cities_00007.png",
        "/uploads/images/contests/cities/gallery/cities_00008.png",
        "/uploads/images/contests/cities/gallery/cities_00009.jpg",
        "/uploads/images/contests/cities/gallery/cities_00010.jpg",
        "/uploads/images/contests/cities/gallery/cities_00011.jpg",
        "/uploads/images/contests/cities/gallery/cities_00012.jpg",
        "/uploads/cities/1d9dc990e0407eca759ca75cbd6b5b30.jpg",
        "/uploads/cities/9dd295508716cfecf43bd172b70865d0.jpg",
        "/uploads/cities/2687d2d67aed03fb5445b1882ccc08bf.jpg",
    ]);

    useEffect(() => {
        getCitiesGallery().then(g => {
            setImages(g);
        });
    });

    return (
        <PhotoCarousel
            images={images.map(i => getStaticUrl(i))}
        />
    );
}